import { useState } from 'react';
import { FormattedNumber, FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { useTrackPromoModal } from './hooks/use-track-promo-modal';
import { bannerMessages } from './messages';
import { ModalsToShow, NewLineupPromotionalMigrationLoader } from './new-lineup-promotional-migration-loader';
import { useGetPromotionalMigrationPlan } from './use-get-promotional-migration-plan';
import { PromotionalBanner } from '../../../../../components/promotional-banner';
import { useGlobalModalLaunchContext } from '../../../../../contexts/modal-context/global-modal-context';
import { useEnableSelfMigration } from '../../../../../feature-flags/hooks/use-enable-self-migration';

export const MigratePlanBanner = ({ className }) => {
  const [showOffer, setShowOffer] = useState(false);
  const { promotionalPlanDetails } = useGetPromotionalMigrationPlan();
  const { trackPromoStartEvent } = useTrackPromoModal();
  const isSelfMigrationEnabled = useEnableSelfMigration();
  const { openManageSubscriptionDrawer } = useGlobalModalLaunchContext();

  const openOfferModal = () => {
    if (isSelfMigrationEnabled) {
      openManageSubscriptionDrawer({
        selectedPlanId: promotionalPlanDetails?.billingPlanId,
      });
    } else {
      setShowOffer(true);
    }
    trackPromoStartEvent(ModalsToShow.MigratePlan);
  };

  const closeOfferModal = () => setShowOffer(false);

  if (!promotionalPlanDetails) {
    return null;
  }

  return (
    <>
      <PromotionalBanner
        className={className}
        promotionalHeaderMessage={bannerMessages.headerMessage}
        promotionalSubheaderMessage={
          <FormattedMessage
            {...bannerMessages.subheaderMessage}
            values={{
              planName: promotionalPlanDetails.name,
              percent: <FormattedNumber style='percent' value={promotionalPlanDetails.discountPercentage} />,
            }}
          />
        }
      >
        <Button onClick={openOfferModal} theme={THEME_CONSTANTS.promotional}>
          <FormattedMessage {...bannerMessages.button} />
        </Button>
      </PromotionalBanner>

      {showOffer ? <NewLineupPromotionalMigrationLoader closeOfferModal={closeOfferModal} /> : null}
    </>
  );
};
